import dayjs from '~/timeInit';

import { useGetTourOfferDepartures } from '~/hooks/apis/tours/useTourOffers';

import { Bundle, TourBundleComponent } from '~/types/bundles/bundle';

/** The bundle's tour and the bundle days it covers. Day 0 is the departure date. */
export default function useBundleTourSpan(bundle: Bundle) {
  const tour = bundle.components.find(
    (component): component is TourBundleComponent => component.product_type === 'tour',
  );
  const { data: departures = [] } = useGetTourOfferDepartures(tour?.tour_offer_id);

  // Every departure of a tour runs the same length, so any one gives the days it covers.
  const departure = departures.find((d) => bundle.departure_dates.includes(d.startDate)) ?? departures[0];
  const tourDays = departure ? dayjs(departure.endDate).diff(dayjs(departure.startDate), 'day') + 1 : undefined;
  const startDay = tour?.day_offset ?? 0;

  return {
    tour,
    startDay,
    tourDays,
    endDay: tourDays === undefined ? undefined : startDay + tourDays - 1,
  };
}
